import { attr } from '@ember-data/model';
import { computed } from '@ember/object';
import { fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
import Fragment from 'ember-data-model-fragments/fragment';

export default class GoodFaithEstimateSubmissionData extends Fragment {
  @fragmentArray('good-faith-estimate/client') clients;
  @fragmentArray('good-faith-estimate/product') products;
  @fragmentArray('good-faith-estimate/service') services;
  @fragment('good-faith-estimate/provider') provider;

  @attr() servicesStartDate;
  @attr() servicesEndDate;
  @attr() diagnosisCodes;
  @attr() notes;
  @attr() legalCopyVersion;

  @computed('services.@each.total')
  get servicesTotal() {
    return this.services.reduce((acc, { total }) => {
      return (acc += total || 0);
    }, 0);
  }

  get items() {
    return [...this.services.toArray(), ...this.products.toArray()].sortBy('position');
  }

  get totalEstimatedCost() {
    return this.items.reduce((sum, item) => sum + (item.total || 0), 0);
  }
}
